const { pages, business, coachingOffers } = require('./seo.json');

const isPreview = (origin) => /(^localhost$|^127\.|\.preview\.|\.localhost$)/i.test(new URL(origin).hostname);
const publicPaths = Object.keys(pages).filter((path) => pages[path].indexable);
const FAQ_PATHS = ['/', '/kurse', '/coaching'];

function getSeo(pathname, siteUrl, faq = null, extra = {}) {
  const origin = new URL(siteUrl).origin;
  const path = pathname.replace(/\/+$/, '') || '/';
  const page = pages[path] || (path.startsWith('/sign-in/') ? pages['/sign-in'] : path.startsWith('/sign-up/') ? pages['/sign-up'] : path.startsWith('/bestaetigen/') ? pages['/bestaetigen'] : path.startsWith('/termin-wahl/') ? pages['/termin-wahl'] : path.startsWith('/registriert/') ? pages['/registriert'] : null);
  const canonicalPath = path.startsWith('/sign-in/') ? '/sign-in' : path.startsWith('/sign-up/') ? '/sign-up' : path;
  const canonical = `${origin}${canonicalPath === '/' ? '/' : canonicalPath}`;
  const isTopic = Boolean(page?.indexable && !FAQ_PATHS.includes(path) && page.name && path.endsWith('-flensburg'));
  const faqItems = faq && (FAQ_PATHS.includes(path) || isTopic) ? faq : null;
  const structuredData = page?.indexable ? [
    {
      '@context': 'https://schema.org',
      '@type': 'ExerciseGym',
      '@id': `${origin}/#studio`,
      ...business,
      url: `${origin}/`,
      image: `${origin}/img/og.jpg`,
      logo: `${origin}/logo-black.png`,
      priceRange: '€€',
      ...(extra.team ? { employee: extra.team.map((t) => ({ '@type': 'Person', name: t.name, jobTitle: t.role, image: `${origin}${t.img}`, ...(t.bio ? { description: t.bio } : {}), worksFor: { '@id': `${origin}/#studio` } })) } : {}),
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      '@id': `${origin}/#website`,
      url: `${origin}/`,
      name: 'FlensFitness',
      inLanguage: 'de-DE',
      publisher: { '@id': `${origin}/#studio` },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${canonical}#webpage`,
      url: canonical,
      name: page.title,
      description: page.description,
      inLanguage: 'de-DE',
      isPartOf: { '@id': `${origin}/#website` },
      about: { '@id': `${origin}/#studio` },
    },
    ...(path !== '/' ? [{
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Startseite', item: `${origin}/` },
        ...(path.startsWith('/firmenfitness/') ? [{ '@type': 'ListItem', position: 2, name: pages['/firmenfitness'].name, item: `${origin}/firmenfitness` }] : []),
        { '@type': 'ListItem', position: path.startsWith('/firmenfitness/') ? 3 : 2, name: page.name || page.title, item: canonical },
      ],
    }] : []),
    ...(path === '/coaching' ? [{
      '@context': 'https://schema.org',
      '@type': 'Service',
      '@id': `${canonical}#service`,
      name: 'Personal Training & Coaching',
      serviceType: 'Personal Training',
      areaServed: 'Flensburg',
      provider: { '@id': `${origin}/#studio` },
      url: canonical,
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Coaching-Angebote',
        itemListElement: coachingOffers.map((o) => ({
          '@type': 'Offer', name: o.name, description: o.description, price: o.price, priceCurrency: 'EUR',
          availability: 'https://schema.org/InStock', url: `${origin}${o.url}`,
        })),
      },
    }] : []),
    ...(path === '/kurse' && extra.courses ? [{
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: 'Kurse bei FlensFitness in Flensburg',
      itemListElement: extra.courses.filter((c) => c.category !== 'Open-Zeit').map((c, i) => ({
        '@type': 'ListItem', position: i + 1,
        item: { '@type': 'Service', name: c.title, description: c.summary, category: c.category, areaServed: 'Flensburg', provider: { '@id': `${origin}/#studio` } },
      })),
    }] : []),
    ...(path === '/preise' && extra.prices ? [{
      '@context': 'https://schema.org',
      '@type': 'OfferCatalog',
      name: 'Mitgliedschaften & Preise bei FlensFitness',
      url: canonical,
      itemListElement: [
        ...extra.prices.map((x) => ({
          '@type': 'Offer', name: `Mitgliedschaft ${x.name}`, description: x.features.join(', '), price: x.price, priceCurrency: 'EUR',
          priceSpecification: { '@type': 'UnitPriceSpecification', price: x.price, priceCurrency: 'EUR', unitText: 'Monat', billingDuration: 'P1M' },
          offeredBy: { '@id': `${origin}/#studio` },
        })),
        ...(extra.dropIn || []).filter((d) => /^\d+(,\d+)? €$/.test(d.price)).map((d) => ({
          '@type': 'Offer', name: d.name, description: d.text, price: d.price.replace(' €', '').replace(',', '.'), priceCurrency: 'EUR', offeredBy: { '@id': `${origin}/#studio` },
        })),
      ],
    }] : []),
    ...(faqItems ? [{
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqItems.map((f) => ({ '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } })),
    }] : []),
  ] : null;
  return {
    title: page?.title || 'Seite nicht gefunden | FlensFitness',
    description: page?.description || 'Diese Seite gibt es nicht. Entdecke das Training bei FlensFitness in Flensburg.',
    robots: page?.indexable && !isPreview(origin) ? 'index,follow' : 'noindex,follow',
    canonical,
    image: `${origin}/img/og.jpg`,
    structuredData,
  };
}

module.exports = { pages, publicPaths, isPreview, getSeo, business };
